import React, { useState } from 'react'
import { IconButton } from '@mui/material'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import { Settings } from 'assets/icons/circles/Settings'
import PropTypes from 'prop-types'

export default function PaymentTableRowMenu({ intent, handleSetPaid }) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }
  return (
    <>
      <IconButton
        onClick={handleClick}
        size='small'
        sx={{ ml: 2 }}
        aria-controls={open ? 'account-menu' : undefined}
        aria-haspopup='true'
        aria-expanded={open ? 'true' : undefined}
      >
        <Settings />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        keepMounted
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(1px 1px 2px rgba(0,0,0,0.1))',
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              mr: 1
            },
            // Revert to previous exact width
            width: '167.28px'
          }
        }}
      >
        {intent.paymentStatus !== 'succeeded' && (
          <MenuItem
            value={intent.payIntentId}
            onClick={() => handleSetPaid(intent.payIntentId)}
          >
            Mark as PAID
          </MenuItem>
        )}
      </Menu>
    </>
  )
}

PaymentTableRowMenu.propTypes = {
  intent: PropTypes.object,
  handleSetPaid: PropTypes.func
}
